<template>
  <div
    class="content-view"
    :style="{ position: 'absolute', top: '30px', right: `${offsetRight}px`, zIndex: '90001' }"
  >
    <div
      class="btn-setting"
      :style="{ position: 'absolute', top: '0px', right: `0px`, zIndex: '90001' }"
    >
      <div class="c-f"><i class="el-icon-s-tools m-r5"></i>设置</div>
    </div>
    <div class="pop-view">
      <img class="pop-view-bg" src="@/assets/guide/bg-right.png" />
      <div class="pop-view-top flex-h">
        <img class="pop-view-top-img" src="@/assets/guide/step-one.png" style="width: 100px" />
        <div class="m-l20">
          <div class="c-3 f-17 f-b m-t10">配送方式新增【商家配送】</div>
          <div class="c-9 f-13 m-t15">提升服务力，提高竞争力，帮您挣钱～</div>
        </div>
      </div>
      <div class="pop-view-btn flex-h">
        <el-button class="m-r15" type="text" @click="OneKeyOpenSellerPicker(false)"
          ><span class="next c-6 f-15">下次再说</span></el-button
        >
        <el-button
          style="width: 132px; height: 38px; line-height: 13px; padding-left: 15px"
          class=""
          type="primary"
          @click="OneKeyOpenSellerPicker(true)"
          ><span style="font-size: 15px">开启 [商家配送]</span></el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { GuideKey } from './code'

export default {
  components: {},
  computed: {},
  data() {
    return {
      GuideKey,
      offsetRight: 0
    }
  },
  mounted() {
    this.resizeListener()
    window.addEventListener('resize', this.resizeListener)
  },
  methods: {
    resizeListener() {
      let btnSetting = document.getElementById('mask-setting')
      // console.log('~~~~1~~~~', window.innerWidth, btnSetting.getBoundingClientRect().right);
      let offset = window.innerWidth - btnSetting.getBoundingClientRect().right
      // console.log('~~~~2~~~~', offset);
      this.offsetRight = offset < 0 ? 0 : offset
    },
    OneKeyOpenSellerPicker(isOpen) {
      this.$emit('editGuide', GuideKey.one, isOpen)
    }
  }
}
</script>

<style lang="less" scoped>
.content-view {
  color: #ffffff;
  .btn-setting {
    width: 75px;
    height: 60px;
    line-height: 60px;
    background-color: red;
    font-size: 13px;
    text-align: center;
  }
  .pop-view {
    transform: translate(-185px, 34px);
    .pop-view-bg {
      width: 430px;
      position: absolute;
      left: 96px;
      top: 40px;
    }
    .pop-view-top {
      transform: translate(120px, 70px);
    }
    .pop-view-btn {
      position: absolute;
      right: -159px;
      bottom: -122px;
      .next {
        &:hover {
          color: #333;
        }
      }
    }
  }
}
</style>
